import { CatalogAPI } from "../../../../../api";
import { IMasterProfile } from "../../../../../models/resources/master/IProfile";
import { throwErrorToastrAsync } from "../../../../../utils";
import { setLoadingMasterProfileForm, setMasterProfileForm } from "../../../../reducers/resources/master/profile/form";
import { setLoadingProfileList, setMasterProfileList } from "../../../../reducers/resources/master/profile/list";

import { AppThunk, store } from "../../../../store";


const catalogAPI = new CatalogAPI();

export const fetchMasterProfileList = (): AppThunk => async (dispatch) => {
    try {
        dispatch(setLoadingProfileList(true));
        const response = await catalogAPI.getMasterProfileList();
        dispatch(setMasterProfileList(response));
    } catch (error) {
        throwErrorToastrAsync(error);
    } finally {
        dispatch(setLoadingProfileList(false));
    }
};

export const fetchMasterProfile = (form:IMasterProfile): AppThunk => async (dispatch) => {
    try {
        dispatch(setLoadingMasterProfileForm(true));
        const response = await catalogAPI.getMasterProfile(form);
        dispatch(setMasterProfileForm(response));
    } catch (error) {
        throwErrorToastrAsync(error);
    } finally {
        dispatch(setLoadingMasterProfileForm(false));
    }
};

export const postToMasterProfileForm = (): any => {
    return async (dispatch: any) => {
        const { form } = store.getState().masterProfileForm;

        try {
            dispatch(setLoadingMasterProfileForm(true));
            if (form.id) {
                await catalogAPI.putMasterProfile(form);
            } else {
                await catalogAPI.postMasterProfile(form);
            }
            dispatch(fetchMasterProfileList());
            return true;
        } catch (error) {
            throwErrorToastrAsync(error); dispatch(setLoadingMasterProfileForm(false));
            return false;
        } 
    };
};